const host = 'tesztbe.kapkerkoz.hu';

export const environment = {
    production: true,
    backendHost: host,
    backend: `https://${host}`,
    api: `https://${host}/api`,
    frontend: 'https://teszt.kapkerkoz.hu',
};



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/environments/environment.ts